/**
 * Renders the email footer (signature + unsubscribe) for preview panels.
 *
 * Shows what recipients will see below the email body. Not editable.
 * Used in both Build Sequence preview and Review Emails preview.
 */

import DOMPurify from 'dompurify'

interface EmailFooterPreviewProps {
  /** HTML signature from the sender email account */
  signature?: string
  /** Unsubscribe text from campaign/global settings */
  unsubscribeText?: string
}

export function EmailFooterPreview({
  signature,
  unsubscribeText,
}: EmailFooterPreviewProps) {
  if (!signature && !unsubscribeText) return null

  return (
    <div className="mt-3">
      {signature && (
        <div
          className="max-w-none text-sm leading-snug text-fg-secondary [overflow-wrap:anywhere] [&_p]:my-0"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(signature),
          }}
        />
      )}
      {unsubscribeText && (
        <p className="mt-3 border-t border-line pt-3 text-xs text-fg-secondary/60">
          {unsubscribeText}
        </p>
      )}
    </div>
  )
}
